// extracted by mini-css-extract-plugin
export default {"container":"MM0wFN","gridSmall":"JQNooT","carousel":"i6u9fe","gridDetailed":"G5176R"};